import { module } from 'angular';

import { GROUP_STAGE } from './groupStage';

export const GROUP_STAGE_MODULE = 'spinnaker.core.pipeline.stage.group';
module(GROUP_STAGE_MODULE, [
  GROUP_STAGE,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/stages/group/groupStage.module.ts